module.exports = __webpack_public_path__ + "media/country_flags/ci-63342dcc.png";